import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function Revelation() {
  return <section className="bg-cream py-20 md:py-28" data-id="element-278">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-279">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-280">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal mb-12 text-center leading-tight" data-id="element-281">
            Una forma diferente de{' '}
            <span className="italic text-forest" data-id="element-282">entender tu cuerpo.</span>
          </h2>

          <div className="space-y-7 text-charcoal/80 text-lg md:text-xl leading-relaxed" data-id="element-283">
            <p data-id="element-284">
              <strong className="text-charcoal" data-id="element-285">Código Hormonal 40+</strong>{' '}
              reúne hábitos y estrategias enfocadas en{' '}
              <span className="text-gold font-semibold" data-id="element-286">
                bienestar femenino
              </span>
              , descanso, alimentación consciente y equilibrio diario.
            </p>

            <div className="bg-warm-white p-8 md:p-10 rounded-lg shadow-lg my-10" data-id="element-287">
              <p className="font-serif text-2xl md:text-3xl text-charcoal text-center leading-snug" data-id="element-288">
                No se trata de restricciones extremas.{' '}
                <span className="text-gold italic" data-id="element-289">
                  Se trata de comprender mejor.
                </span>
              </p>
            </div>

            <p data-id="element-290">
              Cómo apoyar tu cuerpo durante esta etapa de vida puede marcar una
              diferencia en cómo te sientes — en tu energía, tu descanso y tu
              relación contigo misma.
            </p>
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="mt-12 text-center" data-id="element-291">
            <motion.a href="#final-cta" onClick={() => trackAddToCart()} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full lg:w-auto bg-forest text-warm-white px-8 py-5 rounded-md text-base md:text-lg font-semibold inline-flex items-center justify-center gap-3 shadow-lg hover:shadow-xl transition-shadow" data-id="element-292">
              Descubrir el Método
              <ArrowRightIcon className="w-5 h-5" data-id="element-293" />
            </motion.a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}